import React, { cloneElement, Fragment } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Navigate } from 'react-router-dom';
import { activeEditIdSelector } from '@store/comparison/selectors';
import { isAppModule } from '@utils/constants';

const { baseUrl } = window.conviva;

const WithModifyComparison = ({ children, activeCompareEditId = null, ...props }) => {
  if (activeCompareEditId === null) {
    if (isAppModule) {
      return <Navigate to={`${baseUrl}/dashboard/app-experience`} replace/>;
    }
    return <Navigate to={`${baseUrl}/dashboard/trends`} replace/>;
  }

  const childElement = cloneElement(children, {
    ...props,
  });
  return <Fragment>{childElement}</Fragment>;
};

const selector = createSelector(activeEditIdSelector, (activeCompareEditId) => ({
  activeCompareEditId,
}));

export default connect(selector, null)(WithModifyComparison);
